import type { InsuranceProvider as BffInsuranceProvider } from "@credit-acceptance/step6-bff-client";
import { queryOptions, useQuery } from "@tanstack/react-query";

import { workbenchInsuranceProvidersApi } from "../../../../../api/client";

export interface InsuranceProvider {
  name: string;
  phone: string;
}

/**
 * @returns {ReturnType<typeof queryOptions>} Session-cached provider lookup options.
 */
export function insuranceProvidersQuery() {
  return queryOptions({
    queryKey: ["insurance-providers"],
    queryFn: async ({ signal }): Promise<InsuranceProvider[]> => {
      const response = await workbenchInsuranceProvidersApi.getInsuranceProviders({ signal });
      return response.data.flatMap(({ name, phone }: BffInsuranceProvider) =>
        name ? [{ name, phone: phone ?? "" }] : []
      );
    },
    // A CAS failure (502) should reach the free-text fallback without retry delay.
    retry: false,
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: Number.POSITIVE_INFINITY,
  });
}

/**
 * @param {boolean} enabled - Fetch only once the user has engaged the insurer name field.
 * @returns {ReturnType<typeof useQuery<InsuranceProvider[]>>} The provider lookup state.
 */
export function useInsuranceProviders(enabled: boolean) {
  return useQuery({ ...insuranceProvidersQuery(), enabled });
}
